var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_38110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.37012C13.3041 2.37012 10.6689 3.16948 8.42753 4.66712C6.18615 6.16477 4.43921 8.29342 3.40762 10.7839C2.37602 13.2744 2.10611 16.0149 2.63201 18.6587C3.15791 21.3026 4.45601 23.7312 6.36215 25.6373C8.26829 27.5435 10.6969 28.8416 13.3407 29.3675C15.9846 29.8934 18.7251 29.6235 21.2156 28.5919C23.7061 27.5603 25.8347 25.8133 27.3324 23.572C28.83 21.3306 29.6294 18.6954 29.6294 15.9997C29.6294 14.2099 29.2768 12.4375 28.5919 10.7839C27.9069 9.13029 26.903 7.62777 25.6374 6.36214C24.3717 5.09651 22.8692 4.09256 21.2156 3.40761C19.562 2.72266 17.7896 2.37012 15.9998 2.37012ZM15.9998 26.9034C13.8432 26.9034 11.7351 26.264 9.94198 25.0658C8.14887 23.8677 6.75132 22.1648 5.92604 20.1724C5.10077 18.18 4.88484 15.9876 5.30556 13.8725C5.72628 11.7574 6.76476 9.81457 8.28967 8.28966C9.81458 6.76475 11.7574 5.72628 13.8725 5.30555C15.9877 4.88483 18.18 5.10076 20.1724 5.92604C22.1648 6.75131 23.8677 8.14887 25.0658 9.94197C26.264 11.7351 26.9035 13.8432 26.9035 15.9997C26.9035 18.8916 25.7547 21.665 23.7098 23.7098C21.665 25.7547 18.8916 26.9034 15.9998 26.9034Z",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4074 11.8518C17.0619 11.8518 17.5925 11.3212 17.5925 10.6666C17.5925 10.0121 17.0619 9.48145 16.4074 9.48145C15.7528 9.48145 15.2222 10.0121 15.2222 10.6666C15.2222 11.3212 15.7528 11.8518 16.4074 11.8518Z",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4074 13.0371C16.093 13.0371 15.7916 13.1798 15.5693 13.4338C15.347 13.6879 15.2222 14.0324 15.2222 14.3916V21.1641C15.2222 21.5233 15.347 21.8678 15.5693 22.1219C15.7916 22.3759 16.093 22.5186 16.4074 22.5186C16.7217 22.5186 17.0231 22.3759 17.2454 22.1219C17.4677 21.8678 17.5925 21.5233 17.5925 21.1641V14.3916C17.5925 14.0324 17.4677 13.6879 17.2454 13.4338C17.0231 13.1798 16.7217 13.0371 16.4074 13.0371Z",
    fill: "#FF5B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_38110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/infoOutline.5191949839496501e9a5fed5ceb1bd78.svg";
export { ForwardRef as ReactComponent };